import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
      <App />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link href="https://fonts.googleapis.com/css2?family=Mali:ital,wght@0,400;0,600;1,400;1,600&family=Manjari:wght@400;700&display=swap" rel="stylesheet"/> 
  </React.StrictMode>,
  document.getElementById('root')
);